import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableRHPage } from '../../Pages/RH/Compagnons/LoadableRHPage';

export const getListRHRoutes = (props: object): AppRouteType => ({
    id: AppRoutes.RH,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.RH,
        component: LoadableRHPage,
        ...props,
    },
});

export const getRHRoutes = (args: object) => [getListRHRoutes(args)];
